import * as Yup from 'yup';


export const intakeSchema = Yup.object().shape({
    supplierID: Yup.string().required(" Select Supplier"),
    intakeDate: Yup.date().required(" Select Date"),
    statusID: Yup.string().required(" Select Status"),



    pricePerKG: Yup.number()
        .typeError("Enter a valid amount")
        .required("Enter Sale Price Per Kg")
        .min(1, "Enter a valid amount")
        .max(999999, "Amount must be less than 6 digits"),
    volume: Yup.number()
        .typeError("Enter a valid Volume")
        .required("Enter Volume")
        .min(1, "Enter a valid Volume")
        .max(999999, "Volume must be less than 6 digits"),
    productID: Yup.string().required(" Select Product Name"),
    // productSizeID: Yup.mixed()
    // .test('is-valid', "Enter a valid Product Size e.g. 2-3 or 1-2", value => {
    //   if (value === undefined || value === null) return false; // reject empty
    //   if (typeof value === 'number') {
    //     return true; // allow numbers like 1, 2, 3
    //   }
    //   if (typeof value === 'string') {
    //     return /^\d+-\d+$/.test(value); // allow only "number-number" strings
    //   }
    //   return false; // reject anything else
    // })
    // .required("Enter Product Size"),
  // productQualityID: Yup.string().required(" Enter Product Quality"),
    // locationID: Yup.string().required(" Enter Location"),
    batchNumber: Yup.string()
    .trim()
    .required(" Enter Batch Num"), // Ensure this rule exists
    claimAmount: Yup.number()
        .nullable() // Allows empty value
        .transform((value, originalValue) =>
            originalValue === "" ? null : value
        ) // Treat empty string as null
        .min(1, "Enter a valid amount")
        .max(999999, "Amount must be less than 6 digits"),
    salePricePerKG: Yup.number()
        .nullable() // Allows empty value
        .transform((value, originalValue) =>
            originalValue === "" ? null : value
        ) // Treat empty string as null
        .min(1, "Enter a valid amount")
        .max(999999, "Amount must be less than 6 digits"),

})